<template>
    <div>
        <el-dialog
            title="发放边框"
            :visible.sync="dialogFrameVisible"
            :append-to-body="true"
            width="400px"
            :center="true"
            top="200px"
            :close-on-click-modal="false"
            :before-close="() => closeFrameDialog()"
        >
            <el-form
                :model="FrameForm"
                :rules="rules"
                ref="FrameForm"
                label-width="100px"
            >
                <el-form-item label="选择边框" prop="frame_id">
                    <el-select v-model="FrameForm.frame_id" placeholder="请选择边框" filterable clearable @change="get_img" class="frame_c">
                        <el-option
                            v-for="item in frame_arr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align: center;"><img :src="img" height="200px" v-if="img" style="border-radius: 10px;"></div>
            <div slot="footer">
                <el-button type="success" plain @click="submit('FrameForm')" >发 放</el-button>
                <el-button plain @click="closeFrameDialog()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { UserGiveFrameRequest } from '@/network/user.js'
import { ShopBoxListRequest,ShopBoxDetailsRequest } from '@/network/shop/ShopBox.js'

export default {
    name:'',
    data(){
        return {
            FrameForm: {
                frame_id: ''
            },
            rules: {
                frame_id: [
                    {
                        required: true,
                        message: '请选择边框',
                        trigger: 'blur',
                    },
                ]
            },
            frame_arr: [],
            img: ''
        }
    },
    computed:{},
    methods:{
        closeFrameDialog() {
            this.FrameForm = {
                frame_id: ''
            }
            this.img = ''
            this.$emit('ExitFrameDialog')
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.FrameForm.user_id = this.id
                UserGiveFrameRequest(this.FrameForm)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$message.success('边框发放成功!')
                            this.$emit('refresh')
                            this.closeFrameDialog()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        get_all_frame() {
            ShopBoxListRequest()
                .then((s) => {
                    if (s.status === 0) {
                        this.frame_arr = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_img(v) {
            if(v) {
                ShopBoxDetailsRequest(v)
                .then((s) => {
                    if (s.status === 0) {
                        this.img = s.result.data.picture[0]['url']
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }

            this.img = ''
        }
    },
    filters:{},
    props:{
        dialogFrameVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        id: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created(){
        this.get_all_frame()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
</style>